import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { firebaseConfig } from "./firebaseConfig";

// LOCAL TESTING ONLY: `npm run dev:emu` points the app at the Firebase emulators on a
// demo project, so features can be exercised end to end against the real database rules
// without touching production data. `import.meta.env.DEV` is false in every production
// build, so this branch is compiled out of what gets deployed.
const USE_EMULATORS = import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true';
const EMU_PROJECT = 'demo-daksha-erp';

const app = initializeApp(USE_EMULATORS
    ? { ...firebaseConfig, projectId: EMU_PROJECT, databaseURL: `https://${EMU_PROJECT}-default-rtdb.firebaseio.com` }
    : firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);

if (USE_EMULATORS) {
    // Ports are overridable so two local test setups can run side by side.
    connectAuthEmulator(auth, `http://127.0.0.1:${import.meta.env.VITE_EMU_AUTH_PORT || 9099}`, { disableWarnings: true });
    connectDatabaseEmulator(db, '127.0.0.1', Number(import.meta.env.VITE_EMU_DB_PORT || 9000));
    console.warn('[firebase] EMULATOR MODE — demo project, local data only.');
}

let messaging = null;
try {
    messaging = getMessaging(app);
} catch (e) {
    console.warn("Messaging not supported in this environment", e);
}

export { app, messaging, getToken, onMessage };
